/**
 * Salutation options of the legacy create-employee basic info step.
 * `labelKey` is the UILM key the Angular template translates; the stored value is unchanged
 * (including the single space the legacy "None" option persists).
 */
const NO_SALUTATION = ' ';

export const SALUTATION_OPTIONS: { value: string; labelKey: string }[] = [
  { value: 'MR', labelKey: 'MR_' },
  { value: 'MRS', labelKey: 'MRS' },
  { value: 'MS', labelKey: 'MISS' },
  { value: NO_SALUTATION, labelKey: 'NONE' },
];
